// service统一出口
import LCRequest from './request'

let BASE_URL = ''
let TIME_OUT = 10000
if (process.env.NODE_ENV === 'development') {
  BASE_URL = '/api'
} else if (process.env.NODE_ENV === 'production') {
  BASE_URL = 'http://183.2.185.179:5000'
  // BASE_URL = 'http://103.118.48.52:5000' // 香港
}

const lcRequest = new LCRequest({
  baseURL: BASE_URL,
  timeout: TIME_OUT
})

export default lcRequest
